import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.EditWatchersPopupContent', {
    popupTitle: 'Add Watchers',
    readOnlyPopupTitle: 'Watchers',
    doneButtonTitle: 'Add Watchers',
    doneButtonText: 'Done',
    noWatchers: 'There is no possible watchers for this document.',
    noWatchersBySearch: 'No watchers found.',
    successText: 'The Watchers have been changed.',
    searchPlaceholder: 'Search ...',
});
